var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action copy-amazon-link",on:{"click":_vm.openLink}},[_vm._v("View On Amazon")])}
var staticRenderFns = []

export { render, staticRenderFns }